import React, { useState } from "react";
import "./FAQ.css";

const faqs = [
    {
        question: "How long does setup take?",
        answer: "Setup is instant. Just sign up, and you’re ready to go with full access."
    },
    {
        question: "Can I cancel anytime?",
        answer: "Yes, you can cancel anytime from your dashboard with a single click."
    },
    {
        question: "Do I need a credit card to start?",
        answer: "No credit card is required to get started. Enjoy the free tier with no upfront cost."
    }
];

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    return (
        <section className="faq-section">
            <h2 className="faq-heading">Frequently Asked Questions</h2>
            <div className="faq-list">
                {faqs.map((item, index) => (
                    <div
                        className={`faq-card ${openIndex === index ? "open" : ""}`}
                        key={index}
                        onClick={() => toggle(index)}
                    >
                        <div className="faq-question-row">
                            <div className="plus-icon">
                                <span className="horizontal" />
                                <span className="vertical" />
                            </div>
                            <h3 className="faq-question">{item.question}</h3>
                        </div>
                        <p className={`faq-answer ${openIndex === index ? "show" : ""}`}>
                            {item.answer}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
